import { useApp } from "@nebulr-group/nblocks-react";
import { useConfig } from "@nebulr-group/nblocks-react/lib/hooks/config-context";
import { NblocksButton } from "@nebulr-group/nblocks-react/lib/components/shared/NblocksButton";
import { AuthLayoutWrapperComponent } from "@nebulr-group/nblocks-react/lib/components/auth/AuthLayoutWrapperComponent"
import { useEffect } from "react";

function MsAzureMarketplaceLanding() {

  const { name } = useApp();
  const { appId, oAuthBaseURI } = useConfig();

  const loginUrl = `${oAuthBaseURI}/url/login/${appId}?forceFederation=ms-azure-ad`;

  useEffect(() => {
    document.title = name ? name : "";
  }, [name]);

  return (
    <AuthLayoutWrapperComponent
      heading={`Your workspace is ready!`}
      subHeading={`Thank you for choosing ${name} through Azure Marketplace. Your workspace is set up and ready to use.`}
    >
      <NblocksButton type="primary" size="lg">
        <a href={loginUrl}>Continue</a>
      </NblocksButton>
    </AuthLayoutWrapperComponent>
  );
}

export default MsAzureMarketplaceLanding;
